import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@lmc-env/environment';

export type PaymentReceiptStatus = 'MISSING' | 'QUEUED' | 'NO_EMAIL';

export interface PaymentReceiptStatusRow {
	status: PaymentReceiptStatus;
	paymentHistoryRowId: number;
	paymentReferenceNo: string | number | null;
	loanNumber: string;
	customerName: string;
	recipientEmail: string | null;
	datePaid: string;
	paymentAmount: string;
}

export interface PaymentReceiptStatusResponse {
	from: string;
	to: string;
	counts: { MISSING: number; QUEUED: number; NO_EMAIL: number };
	rows: PaymentReceiptStatusRow[];
}

export interface PaymentReceiptGenerateResult {
	paymentHistoryRowId: number;
	status: 'QUEUED' | 'NO_EMAIL' | 'NOT_FOUND' | 'FAILED';
	emailQueueId?: number;
	message?: string;
}

export interface PaymentReceiptGenerateResponse {
	summary: Record<string, number>;
	results: PaymentReceiptGenerateResult[];
}

@Injectable({
	providedIn: 'root',
})
export class PaymentReceiptService {
	private readonly apiUrl = `${environment.DO_URL}/v1/payment-receipts`;

	constructor(private http: HttpClient) {}

	getStatus(from: string, to: string): Observable<PaymentReceiptStatusResponse> {
		const params = new HttpParams().set('from', from).set('to', to);
		return this.http.get<PaymentReceiptStatusResponse>(`${this.apiUrl}/status`, { params });
	}

	generate(rowIds: number[]): Observable<PaymentReceiptGenerateResponse> {
		return this.http.post<PaymentReceiptGenerateResponse>(`${this.apiUrl}/generate`, { rowIds });
	}
}